import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import CircularProgress from '@material-ui/core/CircularProgress'

// Icons
import CancelIcon from '@material-ui/icons/Cancel'
import DeleteIcon from '@material-ui/icons/Delete'

// report components
import {
  deletePortalUser,
  deletePosUser,
  publishPosUsers
} from '../../layouts/Aws.js'

export default function DeleteUserDialog (props) {
  const [saving, setSaving] = React.useState(false)
  const [dialogText, setDialogText] = React.useState('Saving')

  const handleSubmit = async () => {
    setSaving(true)

    if (props.userType === 'Portal') {
      deletePortalUser(props.selectedUsers).then(res => {
        if (res.status === 200) {
          props.onSave()
        }

        setSaving(false)
      })
    } else if (props.userType === 'POS') {
      deletePosUser(props.selectedSite, props.selectedUsers).then(async (res) => {
        if (res.status === 200) {
          setDialogText('Publishing changes')
          var publishResponse = await publishPosUsers(props.selectedSite)

          if (publishResponse.status.toString()[0] === '4') {
            props.onSave(publishResponse, 1)
          } else {
            props.onSave(publishResponse, 0)
          }

          setSaving(false)
        }

        setSaving(false)
      })
    }
  }

  const handleClose = (event, reason) => {
    props.onClose(event, reason)
  }

  return (
    <Dialog maxWidth="sm" fullWidth={true} onClose={handleClose} open={props.open}>
      <DialogTitle style={ { textAlign: 'left' } }>
        Delete Users
      </DialogTitle>
      <DialogContent dividers style={{ textAlign: 'center' }}>
        {
          saving === true
            ? <>
              <div style={{ textAlign: 'center' }}>
                <CircularProgress/>
                <div>{dialogText}</div>
              </div>
            </>
            : <p>Are you sure you wish to delete the selected user(s) ?</p>
        }
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          variant="contained"
          onClick={handleSubmit}
          color="primary">
          <><DeleteIcon />&nbsp;</>
            Delete
        </Button>
        <Button
          variant="contained"
          onClick={handleClose}
          color="secondary">
          <CancelIcon />&nbsp;Cancel
        </Button>
      </DialogActions>
    </Dialog>)
}

DeleteUserDialog.propTypes = {
  userType: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedUser: PropTypes.string,
  selectedUsers: PropTypes.array,
  selectedSite: PropTypes.string
}
